import React, { useState } from "react";
import DataTable from "../UI/table/DataTable";
import { useQuery } from "react-query";
import { deleteZones, getZones, updateZones } from "../../MyApi/zones";
import StatusBadge from "../UI/statusBadge";
import TableActions from "../UI/table/TableActions";
import ZonesModal from "./storemodals/zonemodal";
import MapModal from "./storemodals/zonemodal/mapmodal";
import i18next from "i18next";

const ZonesComponent = () => {
  const [showModal, setShowModal] = useState(false);
  const [showMapModal, setShowMapModal] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [modalId, setModalId] = useState("");
  const [locations, setLocations] = useState([]);

  const lang = i18next.language;

  const { data, isLoading, refetch } = useQuery(["zones-data", lang], () =>
    getZones(lang),
  );

  const zoneColumns = [
    { label: "اسم المنطقة", accessor: "name" },
    {
      label: "الحالة",
      render: (row) => (
        <StatusBadge status={row.is_active ? "active" : "inactive"} />
      ),
    },
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          edit={() => openModal("edit", row.id)}
          deleteFn={deleteZones}
          refetch={refetch}
          mutationKey={"deleteZones"}
          id={row.id}
          editPermission="update_zone"
          deletePermission="delete_zone"
          togglePermission="update_zone"
          toggleMutationKey={"toggle-update-zone"}
          toggleFn={(id, status) =>
            updateZones(
              { is_active: status, _method: "PUT", lang: i18next.language },
              id,
            )
          }
          is_active={row.is_active}
        />
      ),
    },
  ];

  const systemData = data?.data?.zones || [];

  const openModal = (mode, id) => {
    setShowModal(true);
    setModalMode(mode);
    setModalId(id);
  };

  const closeModal = (type, mode) => {
    setShowModal(false);
    setModalMode("add");
    setModalId("");
    if (type === "zone" && mode === "edit") {
      setLocations([]);
    }
  };

  const openMapModal = () => {
    setShowMapModal(true);
  };

  const closeMapModal = () => {
    setShowMapModal(false);
  };

  return (
    <>
      <DataTable
        actionLabel="إضافة المناطق"
        createPermission="create_zone"
        onAddClick={() => openModal("add")}
        title="المناطق"
        columns={zoneColumns}
        data={systemData}
        isLoading={isLoading}
      />
      {showModal && (
        <ZonesModal
          locations={locations}
          setLocations={setLocations}
          openModal={openMapModal}
          show={showModal}
          onClose={closeModal}
          refetch={refetch}
          modalMode={modalMode}
          modalId={modalId}
        />
      )}
      {showMapModal && (
        <MapModal
          show={showMapModal}
          onClose={closeMapModal}
          setLocations={setLocations}
          locations={locations}
          modalMode={modalMode}
        />
      )}
    </>
  );
};

export default ZonesComponent;
